import { VehicleIncentive } from '../../types';

/**
 * AFTER filtering for which incentives are eligible,
 * remove mutually exclusive incentives, keeping the one with the higher typicalAmount
 *
 * @param incentives
 * @returns
 */
export const removeMutuallyExclusiveEligibleIncentives = (incentives: VehicleIncentive[]) => {
  const selectedIncentives: VehicleIncentive[] = [];
  const excludedIncentiveIds = [] as number[];
  const excludedIncentives = [] as VehicleIncentive[];

  for (let i = 0; i < incentives.length; i++) {
    const incentive = incentives[i];
    if (excludedIncentiveIds.includes(Number(incentive.id))) {
      continue;
    }

    let toInclude = incentive;

    const mutuallyExclusivePrograms = incentive.mutuallyExclusivePrograms;
    for (const incentiveId of mutuallyExclusivePrograms) {
      let toExclude = incentives.find((inc) => Number(inc.id) === Number(incentiveId));
      if (toExclude) {
        // Determine which to include and which to exclude
        // Keep the one with the higher typicalAmount
        if (Number(toExclude.typicalAmount) > Number(incentive.typicalAmount)) {
          toInclude = toExclude;
          toExclude = incentive;
        }

        excludedIncentiveIds.push(toExclude.id);
        excludedIncentives.push(toExclude);
      }
    }

    selectedIncentives.push(toInclude);
  }

  return [selectedIncentives, excludedIncentives];
};
